/**
 * Contains all event types for the frontend
 */
import { MembersFieldDto } from "./membersTypes";

/**
 * Type of an event for the events overview
 */
export type EventPartialDto = {
  eventId: number;
  workshopId?: number;
  eventName: string;
  location: string | null;
  eventBeginn: Date;
  eventEnd: Date;
  startTime: string | null;
  endTime: string | null;
  registrationFrom: Date | null;
  registrationTo: Date | null;
  amountOfParticipants: number;
  maximumParticipants: number | null;
  type: "WW" | "Netzwerk" | "JBT goes" | "Sonstige" | "Workshop" | "Pflichtworkshop" | "Externer Workshop";
};

/**
 * Type of an event to create
 */
export type CreateEventDto = {
  eventName: string;
  location: string | null;
  eventBeginn: Date;
  eventEnd: Date;
  startTime: string | null;
  endTime: string | null;
  registrationFrom: Date | null;
  registrationTo: Date | null;
  maximumParticipants: number | null;
  description: string;
  type: "WW" | "Netzwerk" | "JBT goes" | "Sonstige";
  organizers: MembersFieldDto[];
};

/**
 * Enum for the role of a member of an event
 */
export enum EventMemberRole {
  Participant = "Teilnehmer",
  Organizer = "Organisator",
}

/**
 * Enum for the arrival of a member of a working weekend
 */
export enum Arrival {
  Ffr = "Freitag früh",
  FvM = "Freitag vor dem Mittagessen",
  FvA = "Freitag vor dem Abendessen",
  SvF = "Samstag vor dem Frühstück",
  SvM = "Samstag vor dem Mittagessen",
  SvA = "Samstag vor dem Abendessen",
  Ssp = "Samstag spät",
}

/**
 * Enum for the departure of a member of a working weekend
 */
export enum Departure {
  FnM = "Freitag nach dem Mittagessen",
  FnA = "Freitag nach dem Abendessen",
  SnF = "Samstag nach dem Frühstück",
  SnM = "Samstag nach dem Mittagessen",
  SnA = "Samstag nach dem Abendessen",
  Son = "Sonntag",
}

/**
 * Type of a member of an event that is a working weekend
 */
export type EventWWMember = {
  eventId: number;
  memberId: number;
  firstName: string;
  lastName: string;
  arrival: Arrival;
  departure: Departure;
  car: boolean;
  seats: number;
  isVegetarian: boolean;
  comment: string;
  status: string;
};

/**
 * Type of the updated event
 */
export type EventDto = {
  eventId: number;
  eventName: string;
  location: string | null;
  eventBeginn: Date;
  eventEnd: Date;
  startTime: string | null;
  endTime: string | null;
  registrationFrom: Date | null;
  registrationTo: Date | null;
  maximumParticipants: number | null;
  description: string;
  type: "WW" | "Netzwerk" | "JBT goes" | "Sonstige";
  organizers: MembersFieldDto[];
  members: MembersFieldDto[]; // is empty for non-WW events
  wwMembers: EventWWMember[]; // is empty for WW events
};

/**
 * Add a specific Member to a specific Working Weekend
 */
export type WWRegistrationDto = {
  arrival: Arrival;
  departure: Departure;
  car: boolean;
  seats: number;
  isVegetarian: boolean;
  comment: string;
};

/**
 * Type for the last working weekend event
 */
export type LastWWDto = {
  eventId: number;
  eventName: string;
  eventBeginn: Date | null;
  eventEnd: Date | null;
};
